export default function AboutIntro() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-6 flex flex-col gap-5">
            <span className="inline-flex w-fit items-center gap-2 text-xs font-label font-medium tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-information-line" aria-hidden="true" />
              品牌介绍
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              一个把"栏目结构"放在第一位的爆料资讯站
            </h2>
            <p className="text-sm md:text-base leading-relaxed text-foreground-700">
              爆料官网以公开可查的信息为基础，围绕娱乐、科技、财经、社会民生、消费维权等十个频道持续发布内容。
              与其堆叠信息流，我们更愿意把内容放进清晰的栏目里——先让你知道"这类内容归哪个频道"，
              再决定要不要往下读。
            </p>
            <p className="text-sm md:text-base leading-relaxed text-foreground-700">
              网站设有频道列表、专题分类、内容板块与统一导航栏四层结构。频道解决"按领域找"，
              专题解决"按主题串"，内容板块解决"按阅读目的选"，导航栏负责把三者连起来。
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-2">
              {[
                { label: '网站定位', value: '爆料资讯门户' },
                { label: '内容基础', value: '公开可查信息' },
                { label: '核心结构', value: '频道 + 专题' },
              ].map((item) => (
                <div key={item.label} className="rounded-md border border-background-300/60 bg-background-100/60 px-4 py-3">
                  <p className="text-xs font-label text-foreground-500">{item.label}</p>
                  <p className="mt-1 font-heading text-sm font-semibold text-foreground-950">{item.value}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="w-full h-64 md:h-[420px] rounded-lg overflow-hidden border border-background-300/60">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20abstract%20illustration%20of%20a%20structured%20content%20archive%20with%20stacked%20paper%20columns%20and%20crimson%20amber%20accent%20lines%20on%20deep%20charcoal%20background%2C%20minimal%20flat%20style%2C%20no%20text&width=1000&height=1200&seq=baoliao-about-01&orientation=portrait"
                alt="爆料官网的内容结构示意配图"
                title="爆料官网 栏目与频道结构 - 关于我们"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}